import React, { useEffect, useState, useMemo } from 'react';
import ReactPlayer from 'react-player';
import { useLocation } from 'react-router';
import Countdown from 'react-countdown';
import cx from 'classnames';

import useViewport from 'hooks/useViewport';
import useAppPacks from 'hooks/useAppPacks';
import usePackInventorySocket from 'hooks/usePackInventorySocket';
import { getPackStats } from 'utils/packs';
import breakpoints from 'constants/breakpoints';

import BuyPackButton from 'shared_components/BuyPackButton';
import CurrencyValue from 'shared_components/CurrencyValue';
import Spinner from 'shared_components/Spinner';
import PacksButton from 'shared_containers/AppHeader/PacksButton';
import Text from 'shared_components/Text';
import { TwitterIcon, DiscordIcon, NewIcon } from 'shared_components/SVGIcons';

import appLogo from 'assets/logos/full_logo.svg';
import styles from '../../styles.module.scss';
import { SignedOutHeaderNavItems } from 'shared_containers/AppHeader/HeaderNavItems';
import TopSalesBlock from 'shared_containers/TopSalesBlockHome';

import nightmareImage from 'assets/backgrounds/nightmares-video.jpeg';

const resizeProgressText = (set?: any) => {
  let size = 10;
  if (window.innerWidth > 450) size = 12;
  if (window.innerWidth > 600) size = 14;
  if (window.innerWidth > 1200) size = 16;
  return set ? set(size) : size;
};

const NIGHTMARES_PACK_PURCHASE_START = '2021-10-28T19:00:00.000Z';

const ClaimYourPiece = (props: React.HTMLProps<HTMLDivElement>) => {
  const location = useLocation();
  const { pack, mutate } = useAppPacks();
  usePackInventorySocket((data) =>
    mutate((items) => {
      if (items) {
        items.forEach((item, i) => {
          item.data.forEach((packTemplate, j) => {
            if (packTemplate.id === data.id)
              items[i].data[j] = {
                ...items[i].data[j],
                cost: data.cost,
                inventoryCount: data.inventoryCount,
              };
          });
        });
      }
      return items;
    })
  );
  const { remainingTilNext, tier, tierProgressWidth } = getPackStats(pack);

  const [progressTextSize, setProgressTextSize] = useState(resizeProgressText);
  useEffect(() => {
    const resize = () => resizeProgressText(setProgressTextSize);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  const { width } = useViewport();

  // For top collectors & sales blocks

  return (
    <div {...props} className={cx(styles.claimYourPiece, props.className)}>
      <div className={styles.introInfo}>
        <div className={styles.leadVideo}>
          <ReactPlayer
            className="react-player"
            url="https://kolectiv-public.s3.eu-west-1.amazonaws.com/assets/landingvideo.mp4"
            width="100%"
            height="100%"
            light
            playing
            autoPlay
            muted
            loop
          />
          {/* <img src={nightmareImage} alt="Let our nightmares be yours" /> */}
        </div>

        {/* {pack && tier ? (
          <div className={styles.onsale}>

            {pack && (
              <Text
                className={styles.totalRemainingText}
                as="p"
                weight="semibold"
                size="sm"
              >
                Only{' '}
                <Text
                  as="p"
                  size="base"
                  weight="extrabold"
                  className={cx(styles.totalCount, styles.gradientText)}
                >
                  {pack.inventoryCount}
                </Text>
                /5000 total packs remain
              </Text>
            )}
          </div>
        ) : (
          <div className={styles.progressSkeleton} />
        )} */}

        <Countdown
          date={NIGHTMARES_PACK_PURCHASE_START}
          renderer={({ hours, minutes, seconds, completed }) =>
            completed ? null : (
              <div className={styles.packCountdown}>
                <Text
                  block
                  className={styles.gradientText}
                  type="white"
                  weight="semibold"
                  size="base"
                >
                  Your Nightmares Begin
                </Text>
                <Text
                  block
                  className={styles.time}
                  type="white"
                  weight="black"
                  size="3xl"
                >
                  {formatTime(hours)}:{formatTime(minutes)}:
                  {formatTime(seconds)}
                </Text>
              </div>
            )
          }
        />

        <BuyPackButton className={styles.gradientBtn} />
      </div>
    </div>
  );
};

const formatTime = (num: number) => num.toString().padStart(2, '0');

export default ClaimYourPiece;
